import React from "react"
import { Link } from "gatsby"
import { css } from "@jsUtils"
import { CONSTANTS, URLS } from "@data"

import LogoSvg from "@assets/svg/logo.svg"
import LogoWhiteBubbles from "@assets/svg/logo-bubbles-white.svg"

import Styles from "./logo.module.scss"

const { MISC } = CONSTANTS

/**
 * Logo component. When in the footer, gets a monochromatic flag
 * @param {object} props - react props
 * @param {string} props.theme - site theme
 * @param {string} props.styleClass - class from wrapper
 * @param {boolean} props.mono - monocolor display only?
 */
const Logo = ({ theme, styleClass, overrideClass = ``, mono = false, logoBubbles = false }) => {
  return (
    <div className={css(Styles.logoWrapper, styleClass, overrideClass)}>
      <Link
        to={URLS.HOMEPAGE}
        aria-label="Exo Home"
        className={css(Styles.logoLink, MISC.LOGO_CLASS)}
      >
        {logoBubbles ? (
          <LogoWhiteBubbles className={Styles.logoBubbles} />
        ) : (
          <LogoSvg
            className={css(Styles[`theme__${theme}`], Styles.logoExo, mono && Styles.mono)}
          />
        )}
      </Link>
    </div>
  )
}

export default Logo
